import { Component, Input } from '@angular/core';
import { TableSection } from 'src/app/model/shared/table-section';

import { documentToHtmlString } from '.';

@Component({
  selector: 'app-api-reference-endpoints-table-section',
  templateUrl: './api-reference-endpoints-table-section.component.html',
  styleUrls: ['./api-reference-endpoints-table-section.component.scss']
})
export class ApiReferenceEndpointsTableSectionComponent {
  @Input() tableSections: TableSection[] = [];
  @Input() isInterfaceDesign: boolean = false;
  @Input() isEndpointTable: boolean = false;
  @Input() isApiReference: boolean = false;
  constructor() {}

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
